import {
  DateFormatTyps,
  StatusBarTextStyle,
} from "../app/core/shared/contentTypes";
import { base_producttype_environment } from "./environment.base.producttype";

/** base environment used to extend by core*/
const _base_environment = {
  useDarkTheme: true,
  /** System runs in production mode */
  //production: false, needs to overwrite by core
  //producttype: YourAPPProductType.webshop, it will be overwritten by base_producttype_environment
  storeVersion: 16,

  // StausBar Text Color
  StatusBarTextStyle: StatusBarTextStyle.styleLightContent,

  // HypCusNumber: number; needs to overwrite by custom
  // CustomerName: string; needs to overwrite by custom

  /** Connection properties for YourAppServer */
  //YourAppServer: { needs to overwrite by custom
  /** Base URI for connection with the API */
  // exemple: BaseURI: "https://YourAppServer.myhypersoftapp.de/",
  /** Client ID for authentificate by API */
  // exemple: ClientID: "YourApp"
  //},

  /** Base URI for image website */
  // ImageServerURI: string; needs to overwrite by custom
  // exemple: ImageServerURI: "https://demo.myhypersoftapp.de/ImageHandler.ashx",

  /** Google API Token to use the GoogleMapsApi */
  /** todo need signing the api calls: https://developers.google.com/maps/documentation/directions/get-api-key */
  GoogleAPIKey: "",

  /** Debug */
  debug: {
    remoteDebugging: false,
    remoteDebuggingUrl: "http://universal.app:1337",
    /** Mobile device write log to file, with mobileUseConsoleLogToo it can setted to tose the consol to (good for debugging with chrome browse) */
    mobileUseConsoleLogToo: true,
  },

  /** Log */
  log: {
    /** error = 0, info (+error) = 1, debug (+error +info) = 2 */
    level: 0,
    optIn: true,
    optInLevel: 3,
  },

  storeURL: {
    GooglePlayStore: "",
    AppleStore: "",
  },

  /** Checkout läuft im Test modus */
  checkout_in_test_mode: false,
  /** Checkout */
  checkout: {
    // Adyen see (https://docs.adyen.com/checkout/release-notes#page-introduction)
    // try load dynamicly https://stackoverflow.com/questions/34489916/how-to-load-external-scripts-dynamically-in-angular#42766146
    adyen: {
      style: {
        href: "https://checkoutshopper-live.adyen.com/checkoutshopper/sdk/5.59.0/adyen.css",
        integrity:
          "sha384-zgFNrGzbwuX5qJLys75cOUIGru/BoEzhGMyC07I3OSdHqXuhUfoDPVG03G+61oF4",
        crossorigin: "anonymous",
      },
      script: {
        src: "https://checkoutshopper-live.adyen.com/checkoutshopper/sdk/5.59.0/adyen.js",
        integrity:
          "sha384-O8p0CLZyOw1jkmYN7ZwJxWzd+sDYRFGpLEffqc+dKye24gFImbU72did4PC7ysTY",
        crossorigin: "anonymous",
      },
      google_script: {
        src: "https://pay.google.com/gp/p/js/pay.js",
      },
    },
  },

  MaterialDatePickerFormat: DateFormatTyps.DDMMYYYY,

  // set interval time for refreshing bonus action points
  BonusActionInterval: 5000,
};

/** Properties of the base_environment */
export const base_environment = {
  ..._base_environment,
  ...base_producttype_environment,
};
